import type { ExamSection, QuestionType } from '@examflow/core';
import { createSectionConstraint } from '@examflow/core';
import {
  sieleListeningDefinition,
  sieleReadingDefinition,
  sieleSpeakingDefinition,
  sieleWritingDefinition,
} from './questionTypes';

/**
 * SIELE 阅读理解部分配置
 */
export const SIELE_READING_SECTION: ExamSection = {
  id: 'reading',
  name: '阅读理解 (Comprensión de lectura)',
  duration: 60,
  /** SIELE Global reading (CL) fixed digital form: 38 items. */
  questionCount: 38,
  questionTypes: ['single_choice' as QuestionType],
  questionTypeConstraints: [createSectionConstraint(sieleReadingDefinition.id)],
};

/**
 * SIELE 听力理解部分配置
 */
export const SIELE_LISTENING_SECTION: ExamSection = {
  id: 'listening',
  name: '听力理解 (Comprensión auditiva)',
  duration: 55,
  /** SIELE Global listening (CA): 38 items. */
  questionCount: 38,
  questionTypes: ['single_choice' as QuestionType],
  questionTypeConstraints: [createSectionConstraint(sieleListeningDefinition.id)],
};

/**
 * SIELE 书面表达部分配置
 */
export const SIELE_WRITING_SECTION: ExamSection = {
  id: 'writing',
  name: '书面表达 (Expresión e interacción escritas)',
  duration: 50,
  /** SIELE Global writing (CEI): 2 tasks. */
  questionCount: 2,
  questionTypes: ['fill_blank' as QuestionType],
  questionTypeConstraints: [createSectionConstraint(sieleWritingDefinition.id)],
};

/**
 * SIELE 口语表达部分配置
 */
export const SIELE_SPEAKING_SECTION: ExamSection = {
  id: 'speaking',
  name: '口语表达 (Expresión e interacción orales)',
  duration: 20,
  /** SIELE Global speaking (CEIO): 5 tasks. */
  questionCount: 5,
  questionTypes: ['fill_blank' as QuestionType],
  questionTypeConstraints: [createSectionConstraint(sieleSpeakingDefinition.id)],
};

/**
 * SIELE 考试部分
 */
export const SIELE_SECTIONS: ExamSection[] = [
  SIELE_READING_SECTION,
  SIELE_LISTENING_SECTION,
  SIELE_WRITING_SECTION,
  SIELE_SPEAKING_SECTION,
];

/**
 * 获取总考试时长（分钟）
 */
export function getTotalDuration(): number {
  return SIELE_SECTIONS.reduce((sum, section) => sum + section.duration, 0);
}
